import src from "IMAGE";
export default { src, width: 1000, height: 1777, blurWidth: 5, blurHeight: 8, blurDataURL: "data:image/webp;base64,UklGRloAAABXRUJQVlA4TE0AAAAvBMABAM1VICICHgigEQQAAIDa/g3gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC4WwUAAIiIPIhCMF4jfvdt9VRY39/QyqLZAwA="};
